import React from "react";
import "./ToggleButton.css";

const ToggleButton = ({
  id,
  isToggled,
  checkedChildren,
  unCheckedChildren,
  onToggle,
}) => {
  const handleClick = (newValue) => {
    if (newValue !== isToggled) {
      onToggle(newValue);
    }
  };

  return (
    <div id={id} className="toggle-button">
      <div
        className={`toggle-option yes ${isToggled ? "active" : ""}`}
        onClick={() => handleClick(true)} 
      >
        {checkedChildren}
      </div>
      <div className="divider"></div>
      <div
        className={`toggle-option no ${!isToggled ? "active" : ""}`}
        onClick={() => handleClick(false)} 
      >
        {unCheckedChildren}
      </div>
    </div>
  );
};

export default ToggleButton;
